import { render, staticRenderFns } from "./SignupStep1.vue?vue&type=template&id=70715af5&"
import script from "./SignupStep1.vue?vue&type=script&lang=js&"
export * from "./SignupStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports